import studentLogo from '../images/studentlife-logo.png';
import tungteeLogo from '../images/TungTee.png';
import tungleuaLogo from '../images/TungLuea-logo.png';
import readeeLogo from '../images/Readee_logo.png';

const projectData = {
  project: [
    {
      title: 'Student Life',
      desc: 'This is an application that helps facilitate for the KMUTT students such as tell what restaurant around KMUTT.',
      link: 'https://github.com/CSSIT22/studentlife',
      type: "github",
      logo: studentLogo,
    },
    {
      title: 'Tung Tee',
      desc: 'This is the apllication that will bring the group of people that interest in the same thing to be together.',
      link: 'https://github.com/jigneng1/TungTee',
      type: "github",
      logo: tungteeLogo,
    },
    {
      title: 'Tung Leua',
      desc: 'This app is use for help the people, restaurant and also reduce the waste food.',
      link: 'https://github.com/sorasora46/Tungleua',
      type: "github",
      logo: tungleuaLogo,
    },
    {
      title: 'Readee',
      desc: 'An application for exchanging secondhand books—discover and swap books with readers in Thailand.',
      link: 'https://github.com/Joeleely/Readee',
      type: "github",
      logo: readeeLogo,
    },
  ],
  service: [
    {
      title: 'Shortlink Service',
      desc: 'A web service that shortens URLs efficiently.',
      link: 'https://shortlink.joevry.com/',
      type: "website",
    },
  ]
};

export default projectData;